(ns ui.state.session.cofx
  (:require
   [re-frame.core :as rf]
   [common.localization :as loc]
   [frontend.state.current-session :as session]))

(rf/reg-cofx
 ::session-context
 (fn [args]
   (let [session-context {:account                      @session/account
                          :account-current-permissions  @session/current-permissions
                          :role                         @session/role
                          :tenant                       @session/tenant
                          :tenant-schema                @session/tenant-schema
                          :default-currency             @session/default-currency
                          :entities                     @session/entities
                          :investment-reservation-types @session/investment-reservation-types
                          :tr                           loc/tr}]
     (assoc args :session-context session-context))))
